<template>
  <BasePage :pageTitle="eventName" back-button show-menu show-footer>
    <div v-if="isLoading" class="text-center mt-3">
      <div class="spinner-border text-primary" role="status"></div>
      <span class="ms-2">{{ __DICT__.loading }}</span>
    </div>

    <template v-if="event">
      <!-- Bridge action: quick link to scan accreditation -->
      <div class="d-flex gap-2 mb-3">
        <button class="btn btn-primary btn-sm flex-fill" :disabled="!ticketEventId" @click="router.push({name: 'Scan Event', params: {ticketId: ticketEventId}})">
          <IconScan class="icon me-1" :size="16" />
          {{ __DICT__.actionMenu.eventAccreditation || 'Event Accreditation' }}
        </button>
      </div>
      <EventDetailsCard title="Event Details" full :event="event" :dietary="dietary"></EventDetailsCard>
      <div v-if="event.food" class="accordion mt-2 mb-2" id="dietaryAccordion">
        <AccordionItem id="collapse-dietaryDetails" title="Dietary Preferences" parent-id="dietaryAccordion">
          <div class="list-group list-group-flush">
            <span v-for="person in dietary"
                  :key="person"
                  class="list-group-item list-group-item-action d-flex align-items-center justify-content-between">
              <span>{{ person.dietaryPreferences }}</span>
            </span>
          </div>
        </AccordionItem>
      </div>


      <PaxAllocation
          :title="__DICT__.participants"
          :inhabitants="participants"
          :show-capacity="false"
          show-count
          show-brand
          :show-dietary="!!event.food"
      ></PaxAllocation>
    </template>

    <div v-else class="alert alert-danger" role="alert">
      {{ __DICT__.eventNotFound }}
    </div>
  </BasePage>
</template>

<script setup>
import {ref, computed, onMounted} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {IconScan} from '@tabler/icons-vue'
import {useWeekStore} from '@/stores/week.js'
import BasePage from "@/components/BasePage.vue"
import PaxAllocation from "@/components/PaxAllocation.vue"
import EventDetailsCard from "@/components/EventDetailsCard.vue"
import AccordionItem from "@/components/atomic/AccordionItem.vue"
import {api} from "@/services/api.js";

const route = useRoute()
const router = useRouter()
const weekStore = useWeekStore()
const isLoading = ref(true)
const weekData = ref([])
const event = ref(null)
const ticketEventId = ref(null)

const eventName = computed(() =>
    event.value ? event.value.name : __DICT__.event
)

const participants = computed(() =>
    weekData.value.filter(passenger =>
        passenger.allocPlaces?.some(place =>
            place.event?.reference.split('-')[2] === route.params.eventId
        )
    )
)

const dietary = computed(() => {
  return participants.value.filter(p => !p.dietaryPreferences.startsWith('No Dietary') && p.dietaryPreferences !== '')
})

onMounted(async () => {
  try {
    weekData.value = await weekStore.weekData
    const firstParticipant = weekData.value.find(passenger =>
        passenger.allocPlaces?.some(place =>
            place.event?.reference.split('-')[2] === route.params.eventId
        )
    )
    const foodInfo = await api.get(`/api/events/refInfo/${route.params.eventId}`)
    event.value = firstParticipant?.allocPlaces.find(
        place => place.event?.reference.split('-')[2] === route.params.eventId
    )?.event || null
    if (foodInfo.success) {
      event.value.food = foodInfo.data.food
      ticketEventId.value = foodInfo.data.eventId
    } else {
      event.value.food = undefined
    }
  } catch (error) {
    console.error('Error loading event data:', error)
  } finally {
    isLoading.value = false
  }
})
</script>